// eslint-disable-next-line no-shadow
export enum PriorityView {
	QUALITY = 'Quality',
	SPEED = 'Speed',
}
